<template>
    <section class="questionwrapper">
      <div class="helper-holder">
        <!--https://freshman.tech/wikipedia-javascript/-->
        <p>Please, explain the concept of:</p>
        <!--<input type="text" id="input-question4" v-model="watchConcept" @keyup="fetchData"/>-->
        <input type="text" id="input-question4" v-model="watchConcept" @keyup="keymonitor"/>
        <label for="input-question4">Choose a concept</label>

        <!--<ul>
            <li v-for="(result, i) in results" v-bind:key="result.i">{{ result.extract }}</li>
        </ul>

        <p>{{ watchConcept }}</p>-->
      </div>
    </section>
</template>

<script>
export default {
  data: function () {
    return {
      // users: [],
      results: [],
      watchConcept: '',
      myEvent: { key: '' },
      enterPressedC: false,
      hasAnsweredC: false
    };
  },
  methods: {
    // hämta data med vue-resource från wikipedia
    // https://freshman.tech/wikipedia-javascript/
    // https://en.wikipedia.org/w/api.php?action=query&format=json&prop=info%7Cextracts&generator=search&exsentences=1&exlimit=10&exintro=1&gsrsearch=Amsterdam&gsrnamespace=0&gsrlimit=10
    /* fetchData: function () {
      // console.log('fetchData 7');
      const searchText = 'https://en.wikipedia.org/w/api.php?action=query&format=json&prop=info%7Cextracts&explaintext&generator=search&exsentences=1&exlimit=10&exintro=1&gsrnamespace=0&gsrlimit=1&origin=*&gsrsearch=';

      // this.$http.get(searchText + 'Amsterdam')
      // this.$http.get(searchText + this.watchConcept)
      this.$http.get(searchText + encodeURIComponent(this.watchConcept))
        .then(response => {
          // console.log('sdf ' + response.json());
          return response.json();
        })
        .then(data => {
          // console.log('data: ' + data);
          this.results = data.query.pages;

          // https://stackoverflow.com/questions/983267/how-to-access-the-first-property-of-an-object-in-javascript
          const myresults = this.results[Object.keys(this.results)[0]];
          // console.log('this.results: ' + this.results[Object.keys(this.results)[0]]);

          // this.$emit('update-answer-four', this.results);
          // return this.results;

          this.$emit('update-answer-four', myresults);

          // this.hasAnsweredC = true;
          this.$emit('enable-button', true);
          return myresults;
        })
        .catch(() => console.log('An error has occurred.'));
    }, */
    /* sendData: function () {
      this.answerObject = this.results;
      console.log('answerObject: ' + this.answerObject);
      this.$emit('update-answer-four', this.answerObject);
    } */

    keymonitor: function (event) { // viktigt att lägga in event i watchdeklarationen av keymonitor
      this.myEvent = event;
      /* console.log('event: ');
      console.log(event);
      console.log('my event: ');
      console.log(this.myEvent); */

      // console.log(event.keyCode);

      // om det är mellanslag eller om man har suddat ut t.ex. 22 och det inte står någonting
      /*       if (event.keyCode === 32 || this.watchConcept.length <= 0) {
        // gör inget
        this.$emit('enable-button', false);
      } else if (event.key === 'Enter') { // om man har tryckt på enter
        this.fetchData();
        console.log('enterPressed in AppQuestion4');
        this.enterPressedC = true;
        this.$emit('enter-pressed-emit', this.enterPressedC);
      } else {
        this.fetchData();
      } */

      // om det är mellanslag eller om man har suddat ut t.ex. 22 och det inte står någonting
      if (event.keyCode === 32 || this.watchConcept.length <= 0) {
        // gör inget
        this.$emit('enable-button', false);
      } else if (event.key === 'Enter') { // om man har tryckt på enter
        // console.log('enter');

        this.$emit('run-go-fetch', true);
        this.$emit('data-string', this.watchConcept);
        this.$emit('enable-button', true);

        /* this.fetchData();
        console.log('enterPressed in AppQuestion4'); */
        this.enterPressedC = true;
        this.$emit('enter-pressed-emit', this.enterPressedC);
      } else {
        // this.fetchData();
        this.$emit('enable-button', true);
        this.$emit('data-string', this.watchConcept);
      }
    }
  },
  watch: {
    watchConcept: function () {
      // this.fetchData();
      this.keymonitor(event);

      // console.log('watcher watchConcept in AppQuestion1.vue has run');
    }
  }
};
</script>

<style>

</style>
